import { Tabs } from "antd";
import React from "react";
import { BevoegdhedenClusterTab } from "~/components/bevoegdheden/BevoegdhedenClusterTab.jsx";
import { DTOtrainingTab } from "~/components/profile/tabs/dtoTraining.jsx";
import { Notities } from "~/components/profile/tabs/notities.jsx";
import { $t } from "~/i18n.js";

export const CardInstructeursboek = ({
  notities,
  pilot,
  behaalde_bevoegdheden,
  bevoegdheden,
  dto_training,
}) => {
  return (
    <Tabs
      defaultActiveKey="vliegers"
      items={[
        {
          key: "notities",
          label: $t("Notities"),
          children: (
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              <Notities notities={notities || []} alleenPublic />
            </div>
          ),
        },
        ...(bevoegdheden
          ? bevoegdheden
              .map(
                (cluster) =>
                  (!cluster.is_dto ||
                    (dto_training &&
                      dto_training[cluster.id] &&
                      dto_training[cluster.id].status === "started")) && {
                    key: cluster.name,
                    label: cluster.name,
                    children: (
                      <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        <BevoegdhedenClusterTab
                          pilot={pilot}
                          behaalde_bevoegdheden={behaalde_bevoegdheden}
                          cluster={cluster}
                        />
                      </div>
                    ),
                  }
              )
              .filter(Boolean)
          : []),
        {
          key: "DTO",
          label: $t("DTO"),
          children: (
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              <DTOtrainingTab
                canWijzigDTO={false}
                dto_training={dto_training}
                bevoegdheden={bevoegdheden}
                pilot={pilot}
              />
            </div>
          ),
        },
      ]}
    />
  );
};
